// Tribunes data - Add new tribunes here
// Each tribune should have: id, title, subtitle, date, author, summary, themes, pdfUrl, content (optional for preview)

export const tribunesData = {
  fr: {
    pageTitle: "Tribunes",
    pageSubtitle: "Nos prises de position publiques",
    pageDescription: "L'ADA publie régulièrement des tribunes sur les enjeux majeurs de la Côte d'Ivoire. Constructive et contributive, notre parole vise à éclairer le débat public et proposer des solutions concrètes.",
    downloadPdf: "Télécharger le PDF",
    readMore: "Lire la tribune",
    themes: "Thèmes",
    publishedOn: "Publié le",
    by: "par",
    allTribunes: "Toutes les tribunes",
    filterByTheme: "Filtrer par thème",
    noTribunes: "Aucune tribune pour le moment.",
    shareTitle: "Partager cette tribune",
    tribunes: [
      {
        id: "simplification-administrative-2025",
        title: "Simplification administrative : l'État doit délivrer plus vite, plus simplement, plus dignement",
        subtitle: "Tribune sur la réforme administrative en Côte d'Ivoire",
        date: "2025-06-05",
        author: "Alpha Diallo, Président, Alliance Démocratique Africaine",
        themes: ["Réforme", "Administration", "Service public"],
        pdfUrl: "https://customer-assets.emergentagent.com/job_d421c419-4dde-41b0-8c5d-74088ffdc0d4/artifacts/mgg5iwaw_ADA_tribune_simplification.pdf",
        summary: "Beaucoup d'Ivoiriens passent encore des heures, parfois des jours, pour obtenir un document. L'ADA propose un plan de 100 jours : délais publics, suivi visible, recours réel. Une réforme de dignité.",
        keyPoints: [
          "Le délai public : chaque document doit avoir un délai connu",
          "Le suivi visible : un numéro unique pour suivre sa demande",
          "Le recours réel : un processus clair en cas de problème",
          "Un plan de 100 jours pour 10 procédures prioritaires",
          "Une réforme territoriale : pas de Côte d'Ivoire à deux vitesses"
        ],
        quote: "Un pays moderne se juge aussi à la manière dont un citoyen ordinaire peut obtenir le document dont il a besoin, simplement et dignement.",
        content: `Beaucoup d'Ivoiriens passent encore des heures — parfois des jours — pour obtenir un document administratif, renouveler une pièce, corriger une erreur, suivre un dossier ou simplement comprendre une procédure. Ce vécu, fait de fatigue, d'attente, d'incertitude et parfois d'humiliation, est un sujet de confiance nationale.

Quand un citoyen perd une journée pour un document, il perd plus que du temps : il perd de l'argent, de l'énergie, un emploi potentiel, une inscription, un compte bancaire, un voyage, une formalité professionnelle. Pour un entrepreneur, le délai, c'est l'activité bloquée, l'investissement reporté, l'embauche différée.

L'administration est le visage de l'État. Une administration lente, opaque ou incompréhensible abîme la confiance.

TROIS PRINCIPES CONCRETS

1. Le délai public — Le citoyen doit savoir à quoi s'attendre. L'incertitude est souvent pire que l'attente.

2. Le suivi visible — Chaque demande doit avoir un numéro unique permettant de suivre son statut : reçue, en cours, en attente de validation, prête, refusée, incomplète.

3. Le recours réel — Quand un dossier dépasse son délai normal, est refusé ou comporte une erreur, il doit exister un processus simple, clair et encadré pour corriger.

UN PLAN DE 100 JOURS

• Trente premiers jours : Identifier les dix procédures les plus sensibles. Cartographier les blocages.

• Trente jours suivants : Simplifier — réduire les pièces demandées, créer des formulaires unifiés, afficher les délais, mettre en place un suivi de base.

• Quarante derniers jours : Publier les premiers résultats — délais moyens, arriérés, causes principales, corrections engagées.

D'UNE CULTURE DE PROCÉDURE À UNE CULTURE DE SERVICE

La simplification ne fragilise pas l'État : elle renforce son autorité. Un État qui répond est un État plus respecté. Un État clair est un État plus légitime. Un État traçable est un État moins contesté.

Côte d'Ivoire solidaire, c'est aussi la solidarité dans l'accès aux droits.`
      },
      {
        id: "securite-routiere-2025",
        title: "Nos routes neuves méritent d'être sécurisées jusqu'au bout",
        subtitle: "Tribune sur la sécurité routière en Côte d'Ivoire",
        date: "2025-05-01",
        author: "Alpha Diallo, Président, Alliance Démocratique Africaine",
        themes: ["Infrastructure", "Sécurité", "Transport"],
        pdfUrl: "https://customer-assets.emergentagent.com/job_d421c419-4dde-41b0-8c5d-74088ffdc0d4/artifacts/o82mqph8_Tribune_ADA_Securite_Routiere.pdf",
        summary: "Jamais nos routes n'ont été aussi belles. Et pourtant, on continue d'y mourir. L'ADA propose un volet sécurité obligatoire dans tout projet routier : glissières, éclairage, aires de repos, et tolérance zéro face à la corruption.",
        keyPoints: [
          "Un volet sécurité obligatoire dans tout projet routier",
          "Un programme national d'aires de repos sur les corridors",
          "Un plan d'éclairage des points noirs accidentogènes",
          "Tolérance zéro face à la corruption des contrôles techniques",
          "Signalisation complète : glissières, balises, marquage au sol"
        ],
        quote: "Une route qui éclaire, qui signale et qui protège la vie de chacun, c'est cela aussi une Côte d'Ivoire Solidaire.",
        content: `Jamais nos routes n'ont été aussi belles. Et pourtant, sur ces mêmes routes, on continue de mourir. Beaucoup. Trop.

La Côte d'Ivoire investit massivement dans son réseau routier, et c'est une bonne chose. Mais construire une route ne se résume pas à couler du bitume. Une route, c'est un système de sécurité complet.

LE VRAI CHANTIER : SÉCURISER LA ROUTE, PAS SEULEMENT LA CONSTRUIRE

Nos belles routes neuves sont encore trop souvent dépourvues des équipements qui sauvent des vies :
• Les glissières de sécurité aux abords des ravins et des ponts
• L'éclairage des zones accidentogènes
• Les balises rétroréfléchissantes et indicateurs lumineux de virage
• Le marquage au sol visible de nuit
• Les aires de repos aménagées et sécurisées

Une route droite et rapide, plongée dans le noir et sans protection, n'est pas une route moderne : c'est une route dangereuse à grande vitesse.

RECONNAÎTRE LES EFFORTS, SANS BAISSER LA GARDE

L'honnêteté commande de le dire : des efforts réels ont été engagés. La modernisation du contrôle technique et le renforcement des conditions d'obtention du permis vont dans le bon sens.

Mais ces efforts butent sur un obstacle : la corruption. À quoi sert un contrôle technique modernisé si une enveloppe suffit à valider un véhicule dangereux ?

LES PROPOSITIONS DE L'ADA

1. Un volet sécurité obligatoire dans tout projet routier
2. Un programme national d'aires de repos sur les corridors interurbains
3. Un plan d'éclairage des points noirs
4. Une tolérance zéro face à la corruption des chaînes de contrôle

Chaque vie perdue sur nos routes est une vie de trop. La sécurité routière n'est pas un luxe. C'est une composante essentielle de toute route digne de ce nom.`
      },
      {
        id: "sante-mentale-2025",
        title: "Santé mentale et addictions : il est temps d'agir",
        subtitle: "Une proposition de politique publique pour la Côte d'Ivoire",
        date: "2025-04-03",
        author: "Alliance Démocratique Africaine",
        themes: ["Santé", "Social", "Jeunesse"],
        pdfUrl: "https://customer-assets.emergentagent.com/job_d421c419-4dde-41b0-8c5d-74088ffdc0d4/artifacts/5vru6fb3_Tribune_ADA_Sante_Mentale_Addictions.pdf",
        summary: "La santé mentale est un angle mort de notre politique de santé publique. L'ADA propose cinq principes d'action : briser le silence, prévenir dès l'école, former les professionnels, accompagner les familles, et mesurer les résultats.",
        keyPoints: [
          "Briser le silence : campagnes de sensibilisation grand public",
          "Prévenir dès l'école : modules de bien-être psychologique",
          "Former les professionnels : psychologues, travailleurs sociaux, enseignants",
          "Accompagner les familles : lignes d'écoute et structures de proximité",
          "Mesurer les résultats : indicateurs nationaux de santé mentale"
        ],
        quote: "La santé mentale n'est pas un luxe. C'est une condition de la performance individuelle et collective. Un pays qui néglige ses esprits fragilise son avenir.",
        content: `Le constat est sans appel : la santé mentale reste un tabou en Côte d'Ivoire. Dépression, anxiété, addictions — ces maux touchent des centaines de milliers d'Ivoiriens dans le silence.

Les chiffres sont alarmants : selon l'OMS, 1 personne sur 4 sera touchée par un trouble mental au cours de sa vie. En Côte d'Ivoire, l'accès aux soins est quasi inexistant hors d'Abidjan. Les addictions (alcool, drogues, écrans) progressent, notamment chez les jeunes.

Ce que l'ADA propose :
1. Briser le silence par des campagnes nationales de sensibilisation
2. Intégrer la santé mentale dans les programmes scolaires dès le primaire
3. Former 500 psychologues et travailleurs sociaux supplémentaires d'ici 5 ans
4. Créer des centres de proximité dans chaque chef-lieu de région
5. Mettre en place un observatoire national de la santé mentale

Le financement ? Réallocation de 2% du budget santé, partenariats avec les mutuelles, et mobilisation de la coopération internationale.

La santé mentale est un investissement, pas une dépense. Un travailleur en bonne santé mentale est plus productif. Un élève épanoui apprend mieux. Une famille stable construit l'avenir.`
      },
      {
        id: "zlecaf-2025",
        title: "ZLECAf et règles d'origine : la Côte d'Ivoire doit se positionner",
        subtitle: "Tribune sur les enjeux de la Zone de Libre-Échange Continentale Africaine",
        date: "2025-03-06",
        author: "Alliance Démocratique Africaine",
        themes: ["Économie", "Commerce", "International"],
        pdfUrl: "https://customer-assets.emergentagent.com/job_d421c419-4dde-41b0-8c5d-74088ffdc0d4/artifacts/lrm38s2v_Tribune_ADA_ZLECAf_Regles_Origine.pdf",
        summary: "La ZLECAf est une opportunité historique pour l'industrie ivoirienne. Mais sans maîtrise des règles d'origine, nos entreprises risquent d'être marginalisées. L'ADA propose une stratégie offensive.",
        keyPoints: [
          "Comprendre les règles d'origine : qui peut exporter quoi, et sous quelles conditions",
          "Former les entreprises ivoiriennes aux certifications d'origine",
          "Créer un guichet unique ZLECAf à Abidjan",
          "Identifier les filières prioritaires : agroalimentaire, textile, cosmétiques",
          "Négocier des règles favorables aux transformateurs locaux"
        ],
        quote: "La ZLECAf n'est pas un cadeau. C'est une compétition. Et dans une compétition, ceux qui connaissent les règles gagnent.",
        content: `La Zone de Libre-Échange Continentale Africaine (ZLECAf) est entrée en vigueur. C'est le plus grand marché unique au monde : 1,3 milliard de consommateurs, 3 400 milliards de dollars de PIB cumulé.

Le problème ? Les règles d'origine. Pour qu'un produit bénéficie des tarifs préférentiels, il doit être "suffisamment transformé" sur le continent. Mais qu'est-ce que "suffisamment" ? C'est là que tout se joue.

Exemple concret : un jus de mangue produit en Côte d'Ivoire avec des mangues ivoiriennes et du sucre importé d'Asie peut-il être exporté en franchise vers le Nigeria ? Ça dépend. Des règles mal négociées peuvent exclure nos transformateurs.

Ce que l'ADA propose :
1. Cartographier les chaînes de valeur ivoiriennes pour identifier les vulnérabilités
2. Former 1000 entreprises aux procédures de certification d'origine d'ici 2026
3. Créer une cellule de veille ZLECAf au Ministère du Commerce
4. Plaider pour des règles d'origine souples dans les secteurs stratégiques
5. Développer les intrants locaux pour réduire la dépendance aux importations

La Côte d'Ivoire a les atouts : position géographique, tissu industriel, ports modernes. Il nous manque la stratégie. C'est maintenant qu'il faut agir.`
      },
      {
        id: "calendrier-scolaire-2025",
        title: "Réforme du calendrier scolaire : aligner l'école sur la réalité ivoirienne",
        subtitle: "Une proposition concrète pour améliorer la performance scolaire et protéger les familles",
        date: "2025-02-06",
        author: "Alliance Démocratique Africaine",
        themes: ["Éducation", "Social", "Réforme"],
        pdfUrl: "https://customer-assets.emergentagent.com/job_d421c419-4dde-41b0-8c5d-74088ffdc0d4/artifacts/ulmqraq9_ADA_Contribution_Calendrier_Scolaire.pdf",
        summary: "Le calendrier scolaire actuel est hérité d'un modèle colonial inadapté au climat et aux réalités ivoiriennes. L'ADA propose une réforme structurelle : deux semestres, rentrée en janvier, grandes vacances en décembre. Une réforme qui ne coûte qu'une décision.",
        keyPoints: [
          "Aligner l'année scolaire sur l'année civile (rentrée en janvier)",
          "Deux semestres clairs au lieu de trois trimestres",
          "Semestre 1 : mi-janvier à fin mai (fondamentaux et intensité)",
          "Semestre 2 : mi-août à fin novembre (consolidation et évaluations)",
          "Grandes vacances en décembre : cohésion familiale et transmission",
          "Collaboration avec la SODEXAM pour fixer les dates avec rigueur"
        ],
        quote: "Le calendrier scolaire n'est pas un détail. C'est une infrastructure de performance et de protection. Si nous voulons des résultats, commençons par régler le tempo.",
        content: `Il y a des réformes qui coûtent cher. Et il y a des réformes qui coûtent surtout... une décision. Le calendrier scolaire appartient à cette deuxième catégorie.

Le constat : notre calendrier scolaire actuel est un héritage administratif ancien, calqué sur les marqueurs saisonniers français — rentrée de septembre, vacances d'été en juillet-août. Ces repères ne correspondent en rien aux séquences climatiques ivoiriennes. Notre pays connaît des périodes de pluies et de sécheresse qui affectent la mobilité, la fatigue, la concentration, et donc les résultats scolaires.

Pourquoi janvier ? Parce que janvier est un vrai point zéro national : on repart, on se réorganise, on réinstalle la discipline du travail. Deux semestres, c'est plus clair que trois trimestres — pour les familles, les enseignants, les élèves.

Ce n'est pas une rupture inconnue : la Côte d'Ivoire a déjà connu une rentrée fixée début janvier (7 janvier 1991). La question n'est donc pas « est-ce possible ? », mais « comment le rendre stable, cohérent et performant ».

Le schéma proposé :
• Semestre 1 (mi-janvier → fin mai) : régularité, fondamentaux, intensité. Courte pause fin février/début mars.
• Pause inter-semestres (juillet-août, 2 à 3 semaines) : repos, activités extra-scolaires, stages découverte.
• Semestre 2 (mi-août → fin novembre) : consolidation, progression, évaluations de fin d'année. Courte pause fin septembre/début octobre.
• Grandes vacances (décembre → mi-janvier, 6 semaines) : pause nationale, cohésion familiale, transmission, détente.

Gouverner, c'est anticiper. Le pays a l'outil (SODEXAM) : il faut s'en servir pour fixer les dates avec sérieux, sécuriser les périodes sensibles et cesser d'improviser.

Côte d'Ivoire solidaire, cela veut dire aussi cela : organiser le temps de l'école pour protéger les enfants, soulager les familles, et encadrer les adolescents. L'ADA est un parti de contribution : nous mettons des solutions prêtes sur la table, pour aider l'État à délivrer.`
      },
      {
        id: "vie-chere-2025",
        title: "Vie chère : stabiliser les prix du quotidien, c'est possible",
        subtitle: "Une proposition concrète pour protéger le pouvoir d'achat des Ivoiriens",
        date: "2025-01-02",
        author: "Alliance Démocratique Africaine",
        themes: ["Économie", "Social", "Pouvoir d'achat"],
        pdfUrl: "https://customer-assets.emergentagent.com/job_d421c419-4dde-41b0-8c5d-74088ffdc0d4/artifacts/7j4btmj7_Tribune_ADA_Vie_Chere.pdf",
        summary: "La vie chère n'est pas une fatalité. L'ADA propose cinq principes d'action et un programme pilote à Yamoussoukro pour stabiliser les prix des produits essentiels.",
        keyPoints: [
          "Transparence : afficher et comparer les prix publiquement",
          "Réduction des pertes entre fermes et marchés",
          "Fluidité : améliorer transport et concurrence",
          "Sécurité : maintenir une réserve de produits essentiels",
          "Preuve : mesurer et publier les résultats"
        ],
        quote: "Une Côte d'Ivoire solidaire, c'est une Côte d'Ivoire où personne n'est abandonné face à la pression du coût de la vie.",
        content: `Le constat que nous connaissons tous : la vie chère touche toutes les familles ivoiriennes. Ce n'est pas un slogan, c'est une réalité quotidienne.

Ce que nous devons comprendre : le problème n'est pas seulement le prix du produit. C'est tout un système - transport, pertes, stockage désorganisé, intermédiaires multiples, ruptures d'approvisionnement, mauvaise circulation de l'information. Cette instabilité, c'est ce que paient les citoyens.

Notre réponse : travailler différemment. Avec méthode, avec preuves, avec résultats visibles. Pas pour accuser, mais pour réduire la pression en organisant, en informant, en éliminant les coûts inutiles, en protégeant les biens essentiels.

Proposition concrète : un pilote à Yamoussoukro, la capitale politique. Mesurer les prix de douze produits essentiels pendant soixante jours, identifier les points de perte, organiser la publication des prix, tester une petite réserve pour le riz et l'huile, évaluer les résultats. Si ça marche, on étend.`
      }
    ]
  },
  en: {
    pageTitle: "Op-Eds",
    pageSubtitle: "Our public positions",
    pageDescription: "ADA regularly publishes op-eds on major issues in Côte d'Ivoire. Constructive and contributive, our voice aims to enlighten public debate and propose concrete solutions.",
    downloadPdf: "Download PDF",
    readMore: "Read the op-ed",
    themes: "Themes",
    publishedOn: "Published on",
    by: "by",
    allTribunes: "All op-eds",
    filterByTheme: "Filter by theme",
    noTribunes: "No op-eds at the moment.",
    shareTitle: "Share this op-ed",
    tribunes: [
      {
        id: "simplification-administrative-2025",
        title: "Administrative Simplification: The State Must Deliver Faster, Simpler, More Dignified",
        subtitle: "Op-ed on administrative reform in Côte d'Ivoire",
        date: "2025-06-05",
        author: "Alpha Diallo, President, African Democratic Alliance",
        themes: ["Reform", "Administration", "Public Service"],
        pdfUrl: "https://customer-assets.emergentagent.com/job_d421c419-4dde-41b0-8c5d-74088ffdc0d4/artifacts/mgg5iwaw_ADA_tribune_simplification.pdf",
        summary: "Many Ivorians still spend hours, sometimes days, to get a document. ADA proposes a 100-day plan: public deadlines, visible tracking, real recourse. A reform of dignity.",
        keyPoints: [
          "Public deadlines: each document must have a known timeframe",
          "Visible tracking: a unique number to follow your request",
          "Real recourse: a clear process in case of problems",
          "A 100-day plan for 10 priority procedures",
          "Territorial reform: no two-speed Côte d'Ivoire"
        ],
        quote: "A modern country is also judged by how an ordinary citizen can obtain the document they need, simply and with dignity.",
        content: `Many Ivorians still spend hours — sometimes days — to obtain an administrative document, renew an ID, correct an error, track a file or simply understand a procedure. This experience, made of fatigue, waiting, uncertainty and sometimes humiliation, is a matter of national trust.

When a citizen loses a day for a document, they lose more than time: they lose money, energy, a potential job, registration, a bank account, a trip, a professional formality. For an entrepreneur, delay means blocked activity, postponed investment, deferred hiring.

The administration is the face of the State. A slow, opaque or incomprehensible administration damages trust.

THREE CONCRETE PRINCIPLES

1. Public deadline — Citizens must know what to expect. Uncertainty is often worse than waiting.

2. Visible tracking — Each request must have a unique number allowing tracking of its status: received, in progress, awaiting validation, ready, rejected, incomplete.

3. Real recourse — When a file exceeds its normal deadline, is rejected or contains an error, there must be a simple, clear and regulated process to correct it.

A 100-DAY PLAN

• First thirty days: Identify the ten most sensitive procedures. Map out bottlenecks.

• Next thirty days: Simplify — reduce required documents, create unified forms, display deadlines, implement basic tracking.

• Last forty days: Publish initial results — average delays, backlogs, main causes, corrections initiated.

FROM A CULTURE OF PROCEDURE TO A CULTURE OF SERVICE

Simplification does not weaken the State: it strengthens its authority. A responsive State is more respected. A clear State is more legitimate. A traceable State is less contested.

Solidary Côte d'Ivoire also means solidarity in access to rights.`
      },
      {
        id: "securite-routiere-2025",
        title: "Our New Roads Deserve Complete Safety",
        subtitle: "Op-ed on road safety in Côte d'Ivoire",
        date: "2025-05-01",
        author: "Alpha Diallo, President, African Democratic Alliance",
        themes: ["Infrastructure", "Safety", "Transport"],
        pdfUrl: "https://customer-assets.emergentagent.com/job_d421c419-4dde-41b0-8c5d-74088ffdc0d4/artifacts/o82mqph8_Tribune_ADA_Securite_Routiere.pdf",
        summary: "Our roads have never been so beautiful. Yet people continue to die on them. ADA proposes mandatory safety components in every road project: guardrails, lighting, rest areas, and zero tolerance for corruption.",
        keyPoints: [
          "Mandatory safety component in every road project",
          "National program for rest areas on corridors",
          "Lighting plan for accident-prone black spots",
          "Zero tolerance for corruption in vehicle inspections",
          "Complete signage: guardrails, reflective markers, road markings"
        ],
        quote: "A road that illuminates, signals and protects everyone's life - that too is a Solidary Côte d'Ivoire.",
        content: `Our roads have never been so beautiful. Yet on these same roads, people continue to die. Many. Too many.

Côte d'Ivoire is investing massively in its road network, and that's a good thing. But building a road is not just about pouring asphalt. A road is a complete safety system.

THE REAL CHALLENGE: SECURING THE ROAD, NOT JUST BUILDING IT

Our beautiful new roads are still too often lacking the equipment that saves lives:
• Safety guardrails near ravines and bridges
• Lighting in accident-prone areas
• Reflective markers and luminous turn indicators
• Night-visible road markings
• Equipped and secure rest areas

A straight, fast road, plunged into darkness and without protection, is not a modern road: it's a dangerous high-speed road.

ADA'S PROPOSALS

1. Mandatory safety component in every road project
2. National program for rest areas on intercity corridors
3. Lighting plan for black spots
4. Zero tolerance for corruption in control chains

Every life lost on our roads is one too many. Road safety is not a luxury. It's an essential component of any road worthy of the name.`
      },
      {
        id: "calendrier-scolaire-2025",
        title: "School Calendar Reform: Aligning Education with Ivorian Reality",
        subtitle: "A concrete proposal to improve school performance and protect families",
        date: "2025-02-06",
        author: "Ivorian Democratic Alliance",
        themes: ["Education", "Social", "Reform"],
        pdfUrl: "https://customer-assets.emergentagent.com/job_d421c419-4dde-41b0-8c5d-74088ffdc0d4/artifacts/ulmqraq9_ADA_Contribution_Calendrier_Scolaire.pdf",
        summary: "The current school calendar is inherited from a colonial model unsuited to Ivorian climate and realities. ADA proposes a structural reform: two semesters, January start, December holidays. A reform that only costs a decision.",
        keyPoints: [
          "Align the school year with the civil calendar (January start)",
          "Two clear semesters instead of three terms",
          "Semester 1: mid-January to end of May (fundamentals and intensity)",
          "Semester 2: mid-August to end of November (consolidation and evaluations)",
          "December holidays: family cohesion and transmission",
          "Collaboration with SODEXAM to set dates rigorously"
        ],
        quote: "The school calendar is not a detail. It is an infrastructure for performance and protection. If we want results, let's start by setting the tempo.",
        content: `There are reforms that are expensive. And there are reforms that cost especially... a decision. The school calendar belongs to this second category.

The observation: our current school calendar is an old administrative heritage, modeled on French seasonal markers - September start, summer holidays in July-August. These benchmarks do not correspond to Ivorian climatic sequences. Our country experiences periods of rain and drought that affect mobility, fatigue, concentration, and therefore academic results.

Why January? Because January is a true national zero point: we start again, we reorganize, we re-establish work discipline. Two semesters is clearer than three terms - for families, teachers, students.

This is not an unknown break: Côte d'Ivoire has already experienced a start date set for early January (January 7, 1991). The question is therefore not "is it possible?", but "how to make it stable, coherent and effective".

The proposed scheme:
• Semester 1 (mid-January → end of May): regularity, fundamentals, intensity. Short break late February/early March.
• Inter-semester break (July-August, 2 to 3 weeks): rest, extracurricular activities, discovery internships.
• Semester 2 (mid-August → end of November): consolidation, progression, end-of-year evaluations. Short break late September/early October.
• Summer holidays (December → mid-January, 6 weeks): national break, family cohesion, transmission, relaxation.

To govern is to anticipate. The country has the tool (SODEXAM): it must be used to set dates seriously, secure sensitive periods, and stop improvising.

A solidarity-based Côte d'Ivoire also means this: organizing school time to protect children, relieve families, and supervise adolescents. ADA is a party of contribution: we put ready-made solutions on the table, to help the State deliver.`
      },
      {
        id: "vie-chere-2025",
        title: "Cost of Living: Stabilizing Everyday Prices is Possible",
        subtitle: "A concrete proposal to protect Ivorians' purchasing power",
        date: "2025-01-02",
        author: "Ivorian Democratic Alliance",
        themes: ["Economy", "Social", "Purchasing Power"],
        pdfUrl: "https://customer-assets.emergentagent.com/job_d421c419-4dde-41b0-8c5d-74088ffdc0d4/artifacts/7j4btmj7_Tribune_ADA_Vie_Chere.pdf",
        summary: "The high cost of living is not inevitable. ADA proposes five principles of action and a pilot program in Yamoussoukro to stabilize prices of essential products.",
        keyPoints: [
          "Transparency: publicly display and compare prices",
          "Reduce losses between farms and markets",
          "Fluidity: improve transport and competition",
          "Security: maintain a reserve of essential products",
          "Proof: measure and publish results"
        ],
        quote: "A united Côte d'Ivoire is one where no one is abandoned in the face of cost of living pressure.",
        content: `The reality we all know: the high cost of living affects all Ivorian families. This is not a slogan, it's a daily reality.

What we must understand: the problem is not just the product price. It's a whole system - transport, losses, disorganized storage, multiple intermediaries, supply disruptions, poor information flow. This instability is what citizens pay for.

Our response: work differently. With method, with evidence, with visible results. Not to accuse, but to reduce pressure by organizing, informing, eliminating unnecessary costs, protecting essential goods.

Concrete proposal: a pilot in Yamoussoukro, the political capital. Measure prices of twelve essential products for sixty days, identify loss points, organize price publication, test a small reserve for rice and oil, evaluate results. If it works, we expand.`
      }
    ]
  },
  pt: {
    pageTitle: "Tribunas",
    pageSubtitle: "As nossas posições públicas",
    pageDescription: "A ADA publica regularmente tribunas sobre as questões principais da Costa do Marfim. Construtiva e contributiva, a nossa voz visa esclarecer o debate público e propor soluções concretas.",
    downloadPdf: "Descarregar PDF",
    readMore: "Ler a tribuna",
    themes: "Temas",
    publishedOn: "Publicado em",
    by: "por",
    allTribunes: "Todas as tribunas",
    filterByTheme: "Filtrar por tema",
    noTribunes: "Nenhuma tribuna de momento.",
    shareTitle: "Partilhar esta tribuna",
    tribunes: [
      {
        id: "simplification-administrative-2025",
        title: "Simplificação administrativa: o Estado deve entregar mais rápido, mais simples, mais dignamente",
        subtitle: "Tribuna sobre a reforma administrativa na Costa do Marfim",
        date: "2025-06-05",
        author: "Alpha Diallo, Presidente, Aliança Democrática Africana",
        themes: ["Reforma", "Administração", "Serviço público"],
        pdfUrl: "https://customer-assets.emergentagent.com/job_d421c419-4dde-41b0-8c5d-74088ffdc0d4/artifacts/mgg5iwaw_ADA_tribune_simplification.pdf",
        summary: "Muitos marfinenses ainda passam horas, às vezes dias, para obter um documento. A ADA propõe um plano de 100 dias: prazos públicos, acompanhamento visível, recurso real. Uma reforma de dignidade.",
        keyPoints: [
          "Prazo público: cada documento deve ter um prazo conhecido",
          "Acompanhamento visível: um número único para seguir o pedido",
          "Recurso real: um processo claro em caso de problema",
          "Um plano de 100 dias para 10 procedimentos prioritários",
          "Reforma territorial: sem Costa do Marfim a duas velocidades"
        ],
        quote: "Um país moderno também se julga pela forma como um cidadão comum pode obter o documento de que precisa, simplesmente e com dignidade.",
        content: `Muitos marfinenses ainda passam horas — às vezes dias — para obter um documento administrativo, renovar uma identificação, corrigir um erro, acompanhar um processo ou simplesmente entender um procedimento. Esta experiência, feita de cansaço, espera, incerteza e às vezes humilhação, é uma questão de confiança nacional.

Quando um cidadão perde um dia por um documento, perde mais do que tempo: perde dinheiro, energia, um emprego potencial, uma inscrição, uma conta bancária, uma viagem, uma formalidade profissional.

A administração é a face do Estado. Uma administração lenta, opaca ou incompreensível prejudica a confiança.

TRÊS PRINCÍPIOS CONCRETOS

1. Prazo público — O cidadão deve saber o que esperar. A incerteza é frequentemente pior do que a espera.

2. Acompanhamento visível — Cada pedido deve ter um número único que permita acompanhar o seu estado: recebido, em curso, aguardando validação, pronto, recusado, incompleto.

3. Recurso real — Quando um processo excede o seu prazo normal, é recusado ou contém um erro, deve existir um processo simples, claro e regulamentado para corrigir.

UM PLANO DE 100 DIAS

• Primeiros trinta dias: Identificar os dez procedimentos mais sensíveis. Mapear os bloqueios.

• Trinta dias seguintes: Simplificar — reduzir documentos exigidos, criar formulários unificados, exibir prazos, implementar acompanhamento básico.

• Últimos quarenta dias: Publicar os primeiros resultados — atrasos médios, atrasos acumulados, causas principais, correções iniciadas.

DE UMA CULTURA DE PROCEDIMENTO A UMA CULTURA DE SERVIÇO

A simplificação não enfraquece o Estado: reforça a sua autoridade. Um Estado que responde é um Estado mais respeitado. Um Estado claro é um Estado mais legítimo.

Costa do Marfim solidária também significa solidariedade no acesso aos direitos.`
      },
      {
        id: "securite-routiere-2025",
        title: "As nossas novas estradas merecem segurança completa",
        subtitle: "Tribuna sobre segurança rodoviária na Costa do Marfim",
        date: "2025-05-01",
        author: "Alpha Diallo, Presidente, Aliança Democrática Africana",
        themes: ["Infraestrutura", "Segurança", "Transporte"],
        pdfUrl: "https://customer-assets.emergentagent.com/job_d421c419-4dde-41b0-8c5d-74088ffdc0d4/artifacts/o82mqph8_Tribune_ADA_Securite_Routiere.pdf",
        summary: "As nossas estradas nunca foram tão bonitas. No entanto, continua-se a morrer nelas. A ADA propõe um componente de segurança obrigatório em cada projeto rodoviário: guardas, iluminação, áreas de descanso e tolerância zero à corrupção.",
        keyPoints: [
          "Componente de segurança obrigatório em cada projeto rodoviário",
          "Programa nacional de áreas de descanso nos corredores",
          "Plano de iluminação dos pontos negros",
          "Tolerância zero à corrupção nas inspeções",
          "Sinalização completa: guardas, balizas, marcação no pavimento"
        ],
        quote: "Uma estrada que ilumina, sinaliza e protege a vida de todos - isso também é uma Costa do Marfim Solidária.",
        content: `As nossas estradas nunca foram tão bonitas. No entanto, nessas mesmas estradas, continua-se a morrer. Muitos. Demasiados.

A Costa do Marfim está a investir massivamente na sua rede rodoviária, e isso é bom. Mas construir uma estrada não é apenas deitar asfalto. Uma estrada é um sistema de segurança completo.

O VERDADEIRO DESAFIO: PROTEGER A ESTRADA, NÃO APENAS CONSTRUÍ-LA

As nossas belas estradas novas ainda carecem demasiado frequentemente do equipamento que salva vidas:
• Guardas de segurança junto a ravinas e pontes
• Iluminação nas zonas de acidente
• Balizas refletoras e indicadores luminosos de curva
• Marcação no pavimento visível à noite
• Áreas de descanso equipadas e seguras

PROPOSTAS DA ADA

1. Componente de segurança obrigatório em cada projeto rodoviário
2. Programa nacional de áreas de descanso nos corredores interurbanos
3. Plano de iluminação dos pontos negros
4. Tolerância zero à corrupção nas cadeias de controlo

Cada vida perdida nas nossas estradas é uma vida a mais. A segurança rodoviária não é um luxo. É um componente essencial de qualquer estrada digna desse nome.`
      },
      {
        id: "calendrier-scolaire-2025",
        title: "Reforma do Calendário Escolar: Alinhar a Educação com a Realidade Marfinense",
        subtitle: "Uma proposta concreta para melhorar o desempenho escolar e proteger as famílias",
        date: "2025-02-06",
        author: "Aliança Democrática Marfinense",
        themes: ["Educação", "Social", "Reforma"],
        pdfUrl: "https://customer-assets.emergentagent.com/job_d421c419-4dde-41b0-8c5d-74088ffdc0d4/artifacts/ulmqraq9_ADA_Contribution_Calendrier_Scolaire.pdf",
        summary: "O calendário escolar atual é herdado de um modelo colonial inadequado ao clima e realidades marfinenses. A ADA propõe uma reforma estrutural: dois semestres, início em janeiro, férias em dezembro. Uma reforma que custa apenas uma decisão.",
        keyPoints: [
          "Alinhar o ano letivo com o ano civil (início em janeiro)",
          "Dois semestres claros em vez de três períodos",
          "Semestre 1: meados de janeiro a fim de maio (fundamentos e intensidade)",
          "Semestre 2: meados de agosto a fim de novembro (consolidação e avaliações)",
          "Férias de dezembro: coesão familiar e transmissão",
          "Colaboração com a SODEXAM para definir datas com rigor"
        ],
        quote: "O calendário escolar não é um detalhe. É uma infraestrutura de desempenho e proteção. Se queremos resultados, comecemos por regular o ritmo.",
        content: `Há reformas que custam caro. E há reformas que custam sobretudo... uma decisão. O calendário escolar pertence a esta segunda categoria.

A constatação: o nosso calendário escolar atual é uma herança administrativa antiga, baseada nos marcadores sazonais franceses — início em setembro, férias de verão em julho-agosto. Estes referências não correspondem às sequências climáticas marfinenses. O nosso país conhece períodos de chuvas e secas que afetam a mobilidade, a fadiga, a concentração e, portanto, os resultados escolares.

Porquê janeiro? Porque janeiro é um verdadeiro ponto zero nacional: recomeçamos, reorganizamo-nos, reinstalamos a disciplina de trabalho. Dois semestres é mais claro que três períodos — para as famílias, os professores, os alunos.

Esta não é uma rutura desconhecida: a Costa do Marfim já conheceu um início fixado para o início de janeiro (7 de janeiro de 1991). A questão não é portanto "é possível?", mas "como torná-lo estável, coerente e eficaz".

O esquema proposto:
• Semestre 1 (meados de janeiro → fim de maio): regularidade, fundamentos, intensidade. Pausa curta no fim de fevereiro/início de março.
• Pausa inter-semestres (julho-agosto, 2 a 3 semanas): descanso, atividades extracurriculares, estágios de descoberta.
• Semestre 2 (meados de agosto → fim de novembro): consolidação, progressão, avaliações de fim de ano. Pausa curta no fim de setembro/início de outubro.
• Grandes férias (dezembro → meados de janeiro, 6 semanas): pausa nacional, coesão familiar, transmissão, relaxamento.

Governar é antecipar. O país tem a ferramenta (SODEXAM): deve ser usada para definir datas com seriedade, proteger períodos sensíveis e parar de improvisar.

Costa do Marfim solidária também significa isto: organizar o tempo escolar para proteger as crianças, aliviar as famílias e enquadrar os adolescentes. A ADA é um partido de contribuição: colocamos soluções prontas na mesa, para ajudar o Estado a cumprir.`
      },
      {
        id: "vie-chere-2025",
        title: "Custo de Vida: Estabilizar os Preços do Quotidiano é Possível",
        subtitle: "Uma proposta concreta para proteger o poder de compra dos marfinenses",
        date: "2025-01-02",
        author: "Aliança Democrática Marfinense",
        themes: ["Economia", "Social", "Poder de compra"],
        pdfUrl: "https://customer-assets.emergentagent.com/job_d421c419-4dde-41b0-8c5d-74088ffdc0d4/artifacts/7j4btmj7_Tribune_ADA_Vie_Chere.pdf",
        summary: "O custo de vida elevado não é uma fatalidade. A ADA propõe cinco princípios de ação e um programa piloto em Yamoussoukro para estabilizar os preços dos produtos essenciais.",
        keyPoints: [
          "Transparência: exibir e comparar preços publicamente",
          "Reduzir perdas entre quintas e mercados",
          "Fluidez: melhorar transporte e concorrência",
          "Segurança: manter uma reserva de produtos essenciais",
          "Prova: medir e publicar resultados"
        ],
        quote: "Uma Costa do Marfim solidária é aquela onde ninguém é abandonado perante a pressão do custo de vida.",
        content: `A realidade que todos conhecemos: o custo de vida elevado afeta todas as famílias marfinenses. Isto não é um slogan, é uma realidade quotidiana.

O que devemos compreender: o problema não é apenas o preço do produto. É todo um sistema - transporte, perdas, armazenamento desorganizado, múltiplos intermediários, ruturas de abastecimento, má circulação de informação. Esta instabilidade é o que os cidadãos pagam.

A nossa resposta: trabalhar de forma diferente. Com método, com provas, com resultados visíveis. Não para acusar, mas para reduzir a pressão organizando, informando, eliminando custos desnecessários, protegendo bens essenciais.

Proposta concreta: um piloto em Yamoussoukro, a capital política. Medir preços de doze produtos essenciais durante sessenta dias, identificar pontos de perda, organizar a publicação de preços, testar uma pequena reserva para arroz e óleo, avaliar resultados. Se funcionar, expandimos.`
      }
    ]
  }
};

// Helper function to get all unique themes
export const getAllThemes = (tribunes) => {
  const themes = new Set();
  tribunes.forEach(tribune => {
    tribune.themes.forEach(theme => themes.add(theme));
  });
  return Array.from(themes);
};

// Helper function to format date
export const formatTribuneDate = (dateString, language) => {
  const date = new Date(dateString);
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  const locales = { fr: 'fr-FR', en: 'en-US', pt: 'pt-PT' };
  return date.toLocaleDateString(locales[language] || 'fr-FR', options);
};
